import { Icon, type IconName } from './Icon';

type StatProps = {
  label: string;
  value: string | number;
  delta?: string;
  trend?: 'up' | 'down';
  icon?: IconName;
  tint?: boolean;
};

/**
 * KPI card used by the dashboards. Direct port of `.stat` from MAFA.
 * `tint` switches to the accent-tinted background to distinguish the
 * primary metric in a row of stats.
 */
export function Stat({ label, value, delta, trend, icon, tint }: StatProps) {
  return (
    <div className={'stat' + (tint ? ' tint' : '')}>
      <div className="sh">
        <span className="slab">{label}</span>
        {icon && (
          <span className="sic">
            <Icon name={icon} />
          </span>
        )}
      </div>
      <div className="sv">{value}</div>
      {delta && <div className={'sd' + (trend === 'up' ? ' up' : trend === 'down' ? ' down' : '')}>{delta}</div>}
    </div>
  );
}
